import { Link } from "react-router-dom";

interface PageLayoutProps {
  children: React.ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className="min-h-screen font-sans bg-[#f4f5f7]">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16 gap-4">
            <Link
              to="/"
              className="flex items-center gap-2 text-gray-500 hover:text-gray-900 transition-colors text-sm cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-left-s-line text-lg"></i>
              </div>
              <span className="font-medium">Help Center</span>
            </Link>
            <div className="ml-auto flex items-center gap-2">
              <div className="w-7 h-7 flex items-center justify-center bg-[#2d2f36] rounded-lg">
                <i className="ri-add-line text-white text-base font-bold"></i>
              </div>
              <span className="text-sm font-semibold text-gray-700 hidden sm:inline">Kingcraft Technologies</span>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 relative z-10">
        {children}
      </main>
    </div>
  );
}
